import { getAllCampaignTemplates } from '../../services/campaigns.service';
import { getAllCampaignsV2, listAllCampaignsV2 } from '../../services/campaignsV2.service';
import {
  ALL_CAMPAIGNS_DATA,
  FETCH_ALL_CAMPAIGN_TEMPLATES,
  FETCH_CAMPAIGNS_REQUEST,
  FETCH_CAMPAIGNS_SUCCESS,
  SET_CAMPAIGN_COUNT,
  UPDATE_CAMPAIGN_STATUS,
} from './campaignTypes';

export const fetchCampaignsRequest = () => {
  return {
    type: FETCH_CAMPAIGNS_REQUEST,
  };
};

export const fetchCampaignsSuccess = (key, campaigns) => {
  return {
    type: FETCH_CAMPAIGNS_SUCCESS,
    payload: { campaigns, key },
  };
};

export const updateCampaignStatus = (status, id) => {
  return {
    type: UPDATE_CAMPAIGN_STATUS,
    payload: { status, id },
  };
};

export const setCampaignCount = ({ count, key }) => {
  return {
    type: SET_CAMPAIGN_COUNT,
    payload: {
      key,
      count,
    },
  };
};

export const fetchAllCampaigns = () => {
  return async (dispatch) => {
    const response = await getAllCampaignsV2();
    if (response?.status) {
      dispatch({ type: ALL_CAMPAIGNS_DATA, payload: response?.data });
    }
  };
};

export const fetchCampaigns = (args) => {
  return async (dispatch) => {
    const currentPage = args?.currentPage || 1;
    const searchQuery = args?.searchQuery || '';
    const emailAccountIds = args?.selectedEmailTeamIds || [];
    const statusFilters = args?.statusFilters || [];
    const key = `${currentPage}-${searchQuery}-${emailAccountIds.join('-')}-${statusFilters.join('-')}`;
    dispatch(fetchCampaignsRequest());
    const response = await listAllCampaignsV2({
      currentPage,
      searchQuery: searchQuery?.length ? searchQuery : undefined,
      emailAccountIds,
      statusFilters,
    });
    if (response?.status) {
      dispatch(fetchCampaignsSuccess(key, response?.data?.campaigns));
      dispatch(setCampaignCount({ key, count: response?.data?.totalCampaigns }));
    }
  };
};

export const fetchAllCampaignTemplates = () => {
  return async (dispatch) => {
    const response = await getAllCampaignTemplates();
    if (response?.status) {
      dispatch({ type: FETCH_ALL_CAMPAIGN_TEMPLATES, payload: response?.data });
    }
  };
};
